export default __webpack_public_path__ + "static/media/blog_inner_25.3a3f1198.jpg";